import { Route, Routes } from "react-router-dom";
import { ImageBatchDetail } from "./ImageBatchDetail.js";
import { ImageCreateTab } from "./ImageCreateTab.js";
import { TelegramChannelsPage } from "./TelegramChannelsPage.js";

/**
 * Everything under `/generate/create/image/*`: the create form (new requests only) and, after Generate, the new request's own page.
 * CREATE is NOT a history screen - earlier requests and Bundles are not listed here: a request waiting for a decision is in REVIEWS and a decided one is in HISTORY.
 */
export function ImageModeRoutes({ tenantId }: { readonly tenantId: string }) {
  return (
    <Routes>
      <Route index element={<ImageCreateTab tenantId={tenantId} />} />
      <Route path="batches/:batchId" element={<ImageBatchDetail tenantId={tenantId} />} />
      <Route path="telegram" element={<TelegramChannelsPage tenantId={tenantId} />} />
    </Routes>
  );
}
